export const TikTokIcon = ({ className }: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      aria-label="TikTok"
    >
      <title>TikTok</title>
      {/* Black square background with rounded corners */}
      <rect
        x="0"
        y="0"
        width="24"
        height="24"
        rx="4"
        fill="#000000"
      />
      {/* White TikTok note icon */}
      <path
        fill="#ffffff"
        d="M17.86 8.52c-.15-.02-.3-.03-.45-.03-.55 0-1.07.1-1.56.28-.16.06-.31.13-.46.21V6.56c0-.07-.05-.12-.12-.12h-2.03c-.07 0-.12.05-.12.12v6.54c0 1.21-.98 2.19-2.19 2.19s-2.19-.98-2.19-2.19.98-2.19 2.19-2.19c.24 0 .47.04.69.11v-2.1c-.22-.03-.45-.05-.69-.05-2.37 0-4.29 1.92-4.29 4.29s1.92 4.29 4.29 4.29 4.29-1.92 4.29-4.29V9.43c.64.47 1.43.75 2.28.75.15 0 .3-.01.45-.03V8.52z"
      />
    </svg>
  );
};
